import LegalPage from '../components/LegalPage';

function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="June 2026">
      <p>
        Bhavani Die Casting Private Limited (&ldquo;Bhavani Die Casting&rdquo;, &ldquo;we&rdquo;,
        &ldquo;us&rdquo;, or &ldquo;our&rdquo;) respects your privacy and is committed to protecting
        the personal information you share with us. This Privacy Policy explains how we collect, use,
        and safeguard information when you visit <strong>bhavanidc.com</strong> or{' '}
        <strong>bhavanidiecasting.com</strong> (together, the &ldquo;Website&rdquo;) or contact us
        regarding our die casting products and services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect information only to respond to enquiries and conduct our business, including:</p>
      <ul>
        <li>
          <strong>Information you provide</strong> — such as your name, company name, designation,
          email address, phone number, and the details of any enquiry, quotation request, drawing,
          specification, or message you send to us.
        </li>
        <li>
          <strong>Recruitment information</strong> — if you share your profile or résumé with us, we
          collect the details contained in those documents.
        </li>
        <li>
          <strong>Technical and usage data</strong> — such as your IP address, browser type, device
          information, and pages visited, collected automatically through standard web technologies.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To respond to enquiries and provide quotations, technical consultation, and support.</li>
        <li>To deliver, manage, and improve our manufacturing products and services.</li>
        <li>To process and evaluate recruitment applications.</li>
        <li>To maintain, secure, and improve the Website and our communications.</li>
        <li>To comply with applicable legal, tax, and regulatory obligations.</li>
      </ul>

      <h2>3. Cookies &amp; Analytics</h2>
      <p>
        The Website may use cookies and similar technologies to operate correctly and to understand
        how visitors use our pages. You can control or disable cookies through your browser settings;
        however, some parts of the Website may not function as intended without them.
      </p>

      <h2>4. How We Share Information</h2>
      <p>
        We do not sell or rent your personal information. We may share it only with trusted service
        providers who support our operations (for example, hosting or communication providers), or
        where required to do so by law, regulation, or legal process. Any technical drawings,
        specifications, or commercial details you share are treated as confidential and used solely
        for the purpose of serving your requirement.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We apply reasonable technical and organisational measures to protect your information against
        unauthorised access, alteration, disclosure, or destruction. No method of transmission over
        the internet is fully secure, and we cannot guarantee absolute security.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain personal information only for as long as necessary to fulfil the purposes described
        in this policy, or as required to meet legal, accounting, or contractual obligations.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        Subject to applicable law, including the Digital Personal Data Protection Act, 2023, you may
        request access to, correction of, or deletion of your personal information, or withdraw any
        consent you have provided. To exercise these rights, please contact us using the details
        below.
      </p>

      <h2>8. Third-Party Links</h2>
      <p>
        The Website may contain links to external sites that we do not operate. We are not responsible
        for the privacy practices or content of those websites and encourage you to review their
        policies.
      </p>

      <h2>9. Children&rsquo;s Privacy</h2>
      <p>
        The Website is intended for business use and is not directed at children. We do not knowingly
        collect personal information from children.
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page
        with a revised &ldquo;Last updated&rdquo; date.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        For any questions about this Privacy Policy or your personal information, please contact us:
      </p>
      <p className="mb-0">
        <strong>Bhavani Die Casting Private Limited</strong><br />
        Plot No. 36, Sector-16, DMIC, Bidkin,<br />
        District Chhatrapati Sambhajinagar (Aurangabad), Maharashtra - 431105, India<br />
        Email: <a className="link-brand" href="mailto:contact@bhvanidc.com">contact@bhvanidc.com</a><br />
        Phone: <a className="link-brand" href="tel:+919545130777">+91 9545130777</a>
      </p>
    </LegalPage>
  );
}

export default PrivacyPolicy;
